function disabledIdsToKey(disabledIds) {
  return Object.entries(disabledIds ?? {}).map(([chapterId, disabledIds]) => `${chapterId}-${Object.entries(disabledIds).map(([id, value]) => `${id},${value}`).join(":")}`).join(";");
}

export { disabledIdsToKey };
//# sourceMappingURL=util.disabled-ids-to-key.js.map
